import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeaturedHighlights from './components/FeaturedHighlights';
import CTASection from './components/CTASection';
import Testimonial from './components/Testimonial';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { SITE_URL } from '@/constants/site';

export default function Home() {
  return (
    <>
      <JsonLd data={{
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        'name': 'CSSBuy Spreadsheet Hub',
        'url': SITE_URL,
        'description': 'The largest centralized spreadsheet hub for Chinese shopping agents. Discover trusted CSSBuy sheets, category guides, and shopping agent comparisons.',
        'publisher': {
          '@type': 'Organization',
          'name': 'CSSSpreadsheet.Quest',
          'logo': {
            '@type': 'ImageObject',
            'url': 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png'
          }
        },
        'potentialAction': {
          '@type': 'SearchAction',
          'target': {
            '@type': 'EntryPoint',
            'urlTemplate': `${SITE_URL}/search?q={search_term_string}`
          },
          'query-input': 'required name=search_term_string'
        }
      }} />
      <main>
        <article>
          <Navbar />
          <Hero />
          <CategoryGrid />
          <AboutSection />
          <FeaturedHighlights />
          <Testimonial />
          <CTASection />
          <Footer />
        </article>
      </main>
    </>
  );
}